export enum STATUS_IMPORT_RSM {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  ERRORS = 'errors',
}
